

























import { defineComponent, ref } from '@vue/composition-api';

import {
  getSubJobs,
} from '@/api/index';
import duplicateSubJob from '@/table/Job/duplicate-sub-job';

const CommonModalWithSubJobDuplicate = defineComponent({
  setup() {
    const modal = ref(null);
    function open() {
      (modal.value as any).open();
    }
    function close() {
      (modal.value as any).close();
    }

    const subJobs = ref([]);
    const getSubJobResult = (data: any) => data.data.data;
    const selectedSubJob = ref(null);

    return {
      modal,
      open,
      close,

      subJobs,
      selectedSubJob,

      duplicateSubJob,
      getSubJobs,
      getSubJobResult,
    };
  },
});

export default CommonModalWithSubJobDuplicate;
